import { ConsoleEmailProvider } from '@/modules/communications/providers/console-email.provider';
import { MockEmailProvider } from '@/modules/communications/providers/mock-email.provider';
import { validateEmailPayload } from '@/modules/communications/email/validateEmailPayload';
import { getEmailTemplate } from '@/modules/communications/templates/template-registry';
import { renderTemplate } from '@/modules/communications/templates/renderTemplate';
import type {
  EmailMessage,
  EmailSendResult,
} from '@/modules/communications/types/email.types';
import type { WebhookEventName } from '@/modules/communications/types/webhook.types';

const provider =
  import.meta.env.VITE_EMAIL_PROVIDER === 'mock'
    ? new MockEmailProvider()
    : new ConsoleEmailProvider();

/** En SPA no hay envío real — solo sandbox/console. */
export async function sendEmail(message: EmailMessage): Promise<EmailSendResult> {
  const v = validateEmailPayload(message);
  if (!v.valid) {
    return {
      ok: false,
      providerId: 'validation',
      sandbox: true,
      error: v.reason ?? 'Invalid email',
    };
  }
  return provider.send(message);
}

export async function sendTemplatedEmail(
  event: WebhookEventName,
  to: string,
  variables: Record<string, string | number>,
): Promise<EmailSendResult> {
  const tpl = getEmailTemplate(event);
  if (!tpl) {
    return { ok: false, providerId: 'template', sandbox: true, error: 'Sin plantilla' };
  }
  return sendEmail({
    to,
    subject: renderTemplate(tpl.subject, variables),
    text: renderTemplate(tpl.text, variables),
    tags: [event],
  });
}
